export default __webpack_public_path__ + "static/media/18.562c7785.png";